import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/ContextSelector/context-selector';
import { css } from '@patternfly/react-styles';
export var ContextSelectorMenuList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContextSelectorMenuList, _React$Component);

  function ContextSelectorMenuList() {
    var _this;

    _classCallCheck(this, ContextSelectorMenuList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContextSelectorMenuList).apply(this, arguments));
    _this.refsCollection = [];

    _this.sendRef = function (index, ref) {
      _this.refsCollection[index] = ref;
    };

    _this.render = function () {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = _this.props,
          className = _a.className,
          isOpen = _a.isOpen,
          children = _a.children,
          props = __rest(_a, ["className", "isOpen", "children"]);

      return React.createElement("ul", Object.assign({
        className: css(styles.contextSelectorMenuList, className),
        hidden: !isOpen,
        role: "menu"
      }, props), _this.extendChildren());
    };

    return _this;
  }

  _createClass(ContextSelectorMenuList, [{
    key: "extendChildren",
    value: function extendChildren() {
      var _this2 = this;

      return React.Children.map(this.props.children, function (child, index) {
        return React.cloneElement(child, {
          sendRef: _this2.sendRef,
          index: index
        });
      });
    }
  }]);

  return ContextSelectorMenuList;
}(React.Component);
ContextSelectorMenuList.defaultProps = {
  children: null,
  className: '',
  isOpen: true
};